import { createBrowserRouter } from "react-router-dom";
import Login from "./Login";
import { RouterProvider } from "react-router-dom";
import ResidentForm from "./ResidentForm";
import BulkUploadPage from "./BulkUploadPage";
import BulkUploadPreviewPage from "./BulkUploadPreviewPage";
import BulkUploadPreviewTablePage from "./UploadPreviewTable";
import Policy from "./common/Policy";
import ValidateClient from "./common/validateclient";

import AuthenticatedLayout from "./AuthenticatedLayout";
// import PropertyViewDetails from "./PropertyViewDetails";
// import SignIn from "./Signin";
import NotFound from "./NotFound";
// import HtmlQrCodeScannerComponent from "../components/common/Html5QrcodeScannerComponent";

const Body = () => {
  const appRouter = createBrowserRouter([
    {
      path: "/",
      element: <Login />,
    },
    {
      path: "/client",
      element: <Login />,
    },
    {
      path: "/client/:clientName",
      element: (
        <ValidateClient>
          <Login />
        </ValidateClient>
      ),
    },
    {
      path: "/PrivacyPolicy",
      element: <Policy />,
    },
    
    {
      path: "*",
      element: <NotFound />,
    },
    
    {
      path: "/client/:clientName/bulk-preview",
      element: (
        <ValidateClient>
          <BulkUploadPreviewPage />
        </ValidateClient>
      ),
    },
    {
      path: "/client/:clientName/bulk-preview-table",
      element: (
        <ValidateClient>
          <BulkUploadPreviewTablePage />
        </ValidateClient>
      ),
    },
    {
      element: <AuthenticatedLayout />,
      children: [
        {
          path: "/client/:clientName/bulk-upload",
          element: (
            <ValidateClient>
              <BulkUploadPage />
            </ValidateClient>
          ),
        },
        {
          path: "/client/:clientName/resident-form",
          element: (
            <ValidateClient>
              <ResidentForm />
            </ValidateClient>
          ),
        },
        {
      path: "/client/:clientName/resident-form",
      element: (
        <ValidateClient>
          <ResidentForm />
        </ValidateClient>
      ),
    },
    {
      path: "/client/:clientName/bulk-upload",
      element: (
        <ValidateClient>
          <BulkUploadPage />
        </ValidateClient>
      ),
    },
      ],
    },
  ]);

  return (
    <div>
      <RouterProvider router={appRouter} />
    </div>
  );
};
export default Body;
